import { render, staticRenderFns } from "./LabelledInfo.vue?vue&type=template&id=3f7dcb46&"
import script from "./LabelledInfo.vue?vue&type=script&lang=js&"
export * from "./LabelledInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports